import lfBaseVideo from './src/index.vue';
import { withInstall } from '../withInstall';

export default withInstall(lfBaseVideo);
